// @flow

import * as Actions from 'actionTypes';

/**
/**
 * It runs the correct action received
 * @param {object} state of the application
 * @param {object} action received
 * @return {object} new object whic represent the new state after the action
 */
const listing = (state: Object = { isLoading: true }, action: Object): any => {
  if (action.type === Actions.FETCH_LISTING) {
    const newState = Object.assign({}, state);
    newState['isLoading'] = true;

    return newState;
  } else if (action.type === Actions.ADD_LISTING) {
    return {
      isLoading: false,
      ...action.listing
    };
  } else if (action.type === Actions.ADD_LISTING_FAILED) {
    return {
      ...state,
      isLoading: false
    };
  }

  return state;
};

export default listing;



// WEBPACK FOOTER //
// ./src/reducers/listing.reducer/index.js